import './whatsapp_media_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappImageMessageContent extends Monitoring.Models.SocialContents.WhatsappMediaMessageContent

  getImageCaption: ->
    @json.whatsappMessage.caption || ''

  getMainText: ->
    @json.whatsappMessage.caption || ''

  hasParent: ->
    @json.parent?
